const DIAG_TO_HOME_ATTR_MAPPING = {
  firstName: 'piiHomeContactFirstName',
  lastName: 'piiHomeContactLastName',
  address1: 'piiHomeAddressLine1',
  address2: 'piiHomeAddressLine2',
  city: 'piiHomeAddressCity',
  state: 'piiHomeAddressState',
  zip: 'piiHomeAddressPostalCode',
  phone: 'piiHomeContactPhoneNumber',
  email: 'piiHomeContactEmailAddress'
}

export const findHomeCustomerValuesForDiagCustomerValues = (customerAttributes) => {
  const attributes = {}

  _.each(_.keys(DIAG_TO_HOME_ATTR_MAPPING), (diagAttrName) => {
    const homeAttrName = DIAG_TO_HOME_ATTR_MAPPING[diagAttrName]

    if (!_.isEmpty(customerAttributes[homeAttrName])) {
      attributes[diagAttrName] = customerAttributes[homeAttrName]
    }
  })

  return attributes
}
